export default "__VITE_ASSET__NF_Eo9us__";